import React from "react";

import { FaArrowDown, FaLightbulb } from "react-icons/fa";

export default function TutorialIntro({ intro, elementId, onContinue }) {
  const paragraphs = String(intro?.content || "")
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  return (
    <section
      id={elementId}
      data-tutorial-section="intro"
      className="scroll-mt-36"
    >
      <article className="relative overflow-hidden rounded-[28px] border border-violet-200 bg-gradient-to-br from-violet-50 via-white to-sky-50 p-5 shadow-sm dark:border-violet-900/40 dark:from-violet-950/40 dark:via-slate-900 dark:to-sky-950/30 sm:p-7">
        <div className="absolute -right-16 -top-20 h-56 w-56 rounded-full bg-violet-200/40 blur-3xl dark:bg-violet-600/10" />

        <div className="relative">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-start">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[20px] bg-gradient-to-br from-violet-600 to-indigo-600 text-xl text-white shadow-lg shadow-violet-600/25">
              <FaLightbulb />
            </div>

            <div className="min-w-0 flex-1">
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-violet-600 dark:text-violet-300">
                {intro?.label || "Bienvenue"}
              </div>

              <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-3xl">
                {intro?.title || "Bienvenue dans votre tutoriel"}
              </h2>

              <div className="mt-4 space-y-3 text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
                {paragraphs.length ? (
                  paragraphs.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))
                ) : (
                  <p>
                    Parcourez les différentes sections pour découvrir votre
                    application.
                  </p>
                )}
              </div>

              {onContinue ? (
                <button
                  type="button"
                  onClick={onContinue}
                  className="mt-6 inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-violet-700 dark:bg-white dark:text-slate-900 dark:hover:bg-violet-200"
                >
                  Commencer le tutoriel
                  <FaArrowDown />
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </article>
    </section>
  );
}
